import { render, staticRenderFns } from "./OrderHeader.vue?vue&type=template&id=5f49963d&scoped=true&"
import script from "./OrderHeader.vue?vue&type=script&lang=js&"
export * from "./OrderHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrderHeader.vue?vue&type=style&index=0&id=5f49963d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f49963d",
  null
  
)

export default component.exports